import { render, staticRenderFns } from "./BannersContainer.vue?vue&type=template&id=3aeec429&scoped=true"
import script from "./BannersContainer.vue?vue&type=script&lang=js"
export * from "./BannersContainer.vue?vue&type=script&lang=js"
import style0 from "./BannersContainer.vue?vue&type=style&index=0&id=3aeec429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeec429",
  null
  
)

export default component.exports